var _excluded = ["emptyStateMessageText", "total", "limit", "fetchMore", "loading"],
    _excluded2 = ["Cell"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import uuid from "uuid/v4";
import EmptyStateMessage from "../elements/empty-state-message";
import Loading from "../elements/loading";
import useInfiniteScroll from "../../hooks/use-infinite-scroll"; // To not use infinite scrolling don't pass in a fetchMore function

var ResponsiveFlexTable = function ResponsiveFlexTable(_ref) {
  var _ref$emptyStateMessag = _ref.emptyStateMessageText,
      emptyStateMessageText = _ref$emptyStateMessag === void 0 ? "Not available" : _ref$emptyStateMessag,
      total = _ref.total,
      limit = _ref.limit,
      fetchMore = _ref.fetchMore,
      loading = _ref.loading,
      props = _objectWithoutProperties(_ref, _excluded);

  var list_ref = React.useRef(null);
  useInfiniteScroll(fetchMore, list_ref.current);
  return /*#__PURE__*/React.createElement("div", {
    className: "et--responsive-flex-table"
  }, props.data.length ? /*#__PURE__*/React.createElement("div", {
    className: "et--responsive-flex-table--container",
    ref: list_ref
  }, loading && /*#__PURE__*/React.createElement(Loading, {
    text: "Loading"
  }), props.data.map(function (datum) {
    return /*#__PURE__*/React.createElement("div", {
      className: "et--responsive-flex-table--item",
      key: uuid()
    }, props.columns.map(function (_ref2) {
      var Cell = _ref2.Cell,
          col = _objectWithoutProperties(_ref2, _excluded2);

      return Cell ? /*#__PURE__*/React.createElement(Cell, _extends({
        key: uuid()
      }, datum)) : /*#__PURE__*/React.createElement("div", {
        className: "et--responsive-flex-table--row",
        key: uuid()
      }, /*#__PURE__*/React.createElement("div", {
        className: "et--responsive-flex-table--row-content"
      }, /*#__PURE__*/React.createElement("span", null, col.header), typeof col.accessor === "function" ? col.accessor(datum) : datum[col.accessor]));
    }));
  })) : /*#__PURE__*/React.createElement(EmptyStateMessage, {
    text: emptyStateMessageText
  }));
};

ResponsiveFlexTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  emptyStateMessageText: PropTypes.string,
  total: PropTypes.number,
  limit: PropTypes.number,
  fetchMore: PropTypes.func
};
export default ResponsiveFlexTable;